import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PartialIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Partial",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M5.28 27.2h21.47c1.8 0 3.26-1.47 3.26-3.27V8.06c0-1.8-1.46-3.27-3.27-3.27H5.26A3.27 3.27 0 0 0 2 8.06v15.89c.01 1.8 1.47 3.25 3.27 3.25zm21.92-3.27c0 .26-.21.47-.47.47h-9.8V16H27.2zm0-15.87v5.13H16.93v-5.6h9.8c.26 0 .47.21.47.47v.02zm-22.4 0c0-.26.21-.47.47-.47h8.87v16.8H5.28a.47.47 0 0 1-.47-.47V8.05Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-8.82 0-16-7.18-16-16C-.14 8.87 4.32 2.75 10.97.62c.6-.19 1.24.14 1.44.74.19.6-.14 1.24-.74 1.44-5.7 1.82-9.53 7.07-9.53 13.06 0 7.56 6.15 13.71 13.71 13.71 5.97 0 11.21-3.81 13.05-9.48.19-.6.83-.93 1.44-.73.6.19.93.84.73 1.44a15.94 15.94 0 0 1-15.22 11.06Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M30.71 17H15.85c-.63 0-1.14-.51-1.14-1.14V1c0-.63.51-1.14 1.14-1.14 8.82 0 16 7.18 16 16 0 .63-.51 1.14-1.14 1.14M17 14.71h12.52C28.97 8.06 23.65 2.74 17 2.19z"
      })]
    })
  }));
};
PartialIcon.displayName = 'PartialIcon';